module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_major/cma_vis-f05e804f0f1a8dd8fb77c959c4a4048c.jpg";